import { cx } from '@orn/shared-web/utils/cx';

interface IDashboardWelcomeHeaderProps {
  /** Pre-resolved informal name for the greeting. Caller picks `preferredName || firstName`. Falls back to a generic greeting when absent. */
  greetingName?: string | null;
  /** When true, render the "Here's what needs your attention today." sub-line. */
  hasCallouts: boolean;
  className?: string;
}

/**
 * Typography-only greeting block inside the dashboard welcome card. Renders the
 * "Welcome back, {name}" heading in Arizona Flare and a conditional sub-line
 * when callouts are present. Pure presentational — no data fetching.
 */
const DashboardWelcomeHeader = ({ greetingName, hasCallouts, className }: IDashboardWelcomeHeaderProps) => {
  const greeting = greetingName ? `Welcome back, ${greetingName}` : 'Welcome back';

  return (
    <div className={cx('flex flex-col items-start gap-1.5 px-5 md:gap-3 md:px-6', className)}>
      <div className="text-primary text-display-md md:text-display-lg font-arizona md:leading-11 leading-[38px] tracking-[-1.08px] md:tracking-[-0.96px]">
        {greeting}
      </div>
      {hasCallouts && (
        <div className="text-secondary text-md font-normal opacity-80 md:font-medium">
          Here&rsquo;s what needs your attention today.
        </div>
      )}
    </div>
  );
};

export default DashboardWelcomeHeader;
